import styled from "styled-components";

export const Wrapper = styled.div`
  height: 300px;
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-top: 20px;
`;

export const FlexRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 10px;
`;

export const PlainQuestion = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 5px;
  padding-left: 8px;
  min-height: 48px;
  box-sizing: border-box;
  border-radius: 4px;
  border-style: bold;
  border-width: 1px;
  border: 1px solid grey;
  width: 100%;
  border-color: #ccc;
`;

export const BoldTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 5px;
`;

export const OfferTitle = styled.h3`
  margin-bottom: 20px;
  margin-top: 25px;
`;

export const customStyles = {
  container: (provided) => ({
    ...provided,
    width: "100%"
  }),
  control: (provided) => ({
    ...provided,
    minWidth: "100%",
    padding: "5px",
    fontSize: "13px"
  }),
  menu: (provided) => ({
    ...provided,
    width: "100%",
    maxHeight: "400px",
    overflowY: "auto"
  }),
  menuList: (provided) => ({
    ...provided,
    padding: "5px 0"
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f1f1f1" : "white",
    color: "black",
    padding: "10px"
  })
};
